<template>
  <div class="cause-contain">
    <div class="mt24">
      <div class="title">各州市游客投诉率情况</div>
      <div class="content">
        <table class="table" border="0" cellspacing="0" cellpadding="0">
          <tr>
            <th>排名</th>
            <th>州市</th>
            <th>投诉量(件)</th>
            <!-- <th v-if="tableList[0].complainRate||tableList[0].complainRate==0">万人投诉率(%)</th> -->
            <!--  v-if="tableList[0].donetimeAvg||tableList[0].donetimeAvg==0" -->
            <th>投诉率</th>
            <th>扣分</th>
          </tr>
          <tr v-for="(item,index) in tableList" :key="index" :class="item.select?'on':''">
            <td>{{index+1}}</td>
            <td>{{item.areaName}}</td>
            <td>{{item.complainNum}}</td>
            <td v-if="item.complainRate||item.complainRate==0">{{ (item.complainRate / 100) +"%"}}</td>
            <td v-if="item.donetimeAvg||item.donetimeAvg==0">{{item.donetimeAvgCN}}</td>
            <td>{{item.deduction/100}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'file',
        props: {
            tableList: {
                type: Array
            },
            areaName: String
        },
        data () {
            return {

            }
        },
        created () {
            var newMenu = this.tableList;
            newMenu.forEach(item => {
                if (item.areaName === this.areaName) {
                    // console.log(item3)
                    item.select = true
                }
            })
        },
    }
</script>

<style lang="less" scoped>
  .cause-contain {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .mt24 {
      margin-top: 24px;
    }

    .title {
      height: 20px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
    }

    .content {
      margin-top: 12px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 3px;
      padding: 16px 16px 8px 16px;

      .table {
        width: 100%;
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;

        tr {
          th {
            color: #333333;
            color: rgba(51, 51, 51, 1);
            font-weight: 400;
            padding-bottom: 10px;
          }

          td {
            color: #666666;
            line-height: 24px;
            display: table-cell;
            vertical-align: middle;
          }
        }

        tr:nth-child(2n+2) {
          background: rgba(54, 179, 116, 0.06);
        }

        tr.on {
          td {
            color: rgba(54, 179, 116, 1);
          }
        }
      }
    }
  }
</style>
